import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserProfile } from "USERPROFILE/userProfileSlice";
import { getAdminDetailsThunk } from "USERPROFILE/supportSlice";
// import { getEmailList } from "USERPROFILE/emailSlice";

import {
  getRecentlyViewedThunk,
  getRecentlyAddedThunk,
  getNabCheckThunk,
  getTagListThunk,
  setSelectedCategoryTagId,
  setRelodeLandingPage,
  getDayCount,
} from "../../redux/features/landingSlice";
import {
  loadNotificationThunk,
} from "../../redux/features/notificationSlice";
import RecentlyAddedItems from "./RecentlyAddedItems";
import RecentlyViewed from "./RecentlyViewed";
import { getClientThunk } from "../../redux/features/loginSlice";
import { Fragment } from "react";

function LandingPageComp({ rightArrow, leftArrow }) {
  const dispatch = useDispatch();
  const { recentlyViewed, recentlyAdded, tagList, recentlyAddedDone } = useSelector(
    (state) => state.landing
  );
  const { companyNumber } = useSelector((state) => state.login);

  const { adminData } = useSelector((state) => state.support);
  const { user } = useSelector((state) => state.accountManage);

  const [labels, setLabels] = useState([]);
  const [WelcomeMessage, setWelcomeMessage] = useState(null);
  const [StartAnOrder, setStartAnOrder] = useState(null);
  const [ContactSupportButton, setContactSupportButton] = useState(null);
  const [RecentlyAdded, setRecentlyAdded] = useState(null); //removed
  const [Categories, setCategories] = useState(null);
  const [RecentlyViewedField, setRecentlyViewedField] = useState(null); //removed
  const [appName, setappName] = useState(null);

  useEffect(() => {
    dispatch(getClientThunk());
  }, []);


  useEffect(()=>{
    if(recentlyAddedDone){
      dispatch(loadNotificationThunk('isLandingPage'));
    }
  },[recentlyAddedDone]);
  const getDayCounts = async () => {
    let newDayCountData = await dispatch(
      getDayCount({ payload: { keyId: "new_item_display_days" } })
    );
    let exDayCountData = await dispatch(
      getDayCount({ payload: { keyId: "expired_item_display_days" } })
    );
    if (newDayCountData && exDayCountData) {
      dispatch(
        getRecentlyViewedThunk({
          payload: {
            companyNumber: companyNumber,
            resultsPerPage: 12,
            pageNumber: 1,
            sortBy: "Recently Viewed",
            newItemDisplayDays: newDayCountData?.payload?.parameterValue
              ? parseInt(newDayCountData?.payload?.parameterValue || 30)
              : 30,
            expiredItemDisplayDays: exDayCountData?.payload?.parameterValue
              ? parseInt(exDayCountData?.payload?.parameterValue || 30)
              : 30,
          },
        })
      );
      dispatch(
        getRecentlyAddedThunk({
          payload: {
            companyNumber: companyNumber,
            resultsPerPage: 12,
            pageNumber: 1,
            sortBy: "Recently Added Items",
            newItems: 1,
            newItemDisplayDays: newDayCountData?.payload?.parameterValue
              ? parseInt(newDayCountData?.payload?.parameterValue || 30)
              : 30,
          },
        })
      );
    }
  };

  useEffect(() => {
    if (companyNumber) {
      dispatch(getAdminDetailsThunk());
      getDayCounts();
      dispatch(setSelectedCategoryTagId(null));

      // dispatch(getNabCheckThunk());
      dispatch(getTagListThunk());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyNumber]);

  useEffect(() => {
    if (
      adminData &&
      adminData.headerLinks &&
      Object.keys(adminData.headerLinks).length !== 0
    ) {
      let data = [];
      for (let value of Object.values(adminData?.headerLinks)) {
        data.push(value);
      }
      setLabels([...data]);
    } else {
      if (companyNumber) dispatch(getAdminDetailsThunk());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adminData]);

  const getDataLabel = (fieldKey) => {
    const arr = Object.entries(labels)?.map((e) => ({ [e[0]]: e[1] }));
    const content = [];
    for (let i in arr) {
      content.push(...Object.values(arr[i]));
    }

    let arr1 = fieldKey;
    let updatedData = content.filter(
      (i) => arr1.toLowerCase() == i.fieldKey.toLowerCase()
    );
    if (updatedData.length) {
      return {
        ...updatedData[0],
        showField:
          updatedData[0]?.fieldVisible == "true"
            ? true
            : updatedData[0]?.fieldVisible == "false"
            ? false
            : updatedData[0]?.fieldVisible == "NA"
            ? updatedData[0]?.defaultFieldVisible == "true"
              ? true
              : false
            : true,
      };
    }
    return null;
  };

  useEffect(() => {
    setWelcomeMessage(getDataLabel("WelcomeMessage"));
    setStartAnOrder(getDataLabel("StartAnOrder"));
    setContactSupportButton(getDataLabel("ContactSupportButton"));
    setRecentlyAdded(getDataLabel("RecentlyAdded")); //removed
    setCategories(getDataLabel("Categories"));
    setRecentlyViewedField(getDataLabel("RecentlyViewed")); //removed
    setappName(getDataLabel("appName"));
  }, [labels]);

  useEffect(() => {
    // dispatch(getUserProfile());
    dispatch(setRelodeLandingPage(0));
  }, []);

  useEffect(() => {
    localStorage.setItem("ssoFlagStatus", user?.ssoFlag ? true : false);
  }, [user]);

  const onContactSupport = () => {
    navigate("/support");
  };
  const onClose = () => {
    return "";
  };

  const onStartAnOrder = () => {
    navigate(`/searchResults`);
  };
  const navigate = useNavigate();
  const onCategorySelect = (tagId) => {
    // dispatch(setSortByValue("Item Code: A-Z"));
    dispatch(setSelectedCategoryTagId(tagId));
    navigate(`/searchResults`, { state: { sortBy: "Item Code: A-Z" } });
  };

  return (
    <main role="main" className="main">
      <div id="infoModal1" className="overlay hide">
        <div className="popup2">
          <div className="body">
            <div className="group">
              <div className="span12">
                <h4 className="float-left">Select an Order Type</h4>
                <div className="close-btn2 float-right">
                  <img onClick={onClose} src="images/close.png" />
                </div>
              </div>
              <div className="clear"></div>
              <div className="span12">
                <div className="overlay-content">
                  <div className="order-type margin-top2">
                    <div className="cart-icon-container">
                      <div className="cart-icon3">
                        <i className="fa fa-user"></i>
                      </div>
                    </div>
                    <div className="returns-content">
                      {" "}
                      <strong>SHIP TO SELF</strong>
                      <br />
                      Ship this order to your shipping address on file.{" "}
                    </div>
                  </div>
                </div>
                <div className="overlay-content">
                  <div className="order-type margin-top2">
                    <div className="cart-icon-container">
                      <div className="cart-icon3">
                        <i className="fa fa-users"></i>
                      </div>
                    </div>
                    <div className="returns-content">
                      {" "}
                      <strong>SHIP TO ONE OR MORE ADDRESSES</strong>
                      <br />
                      Ship this order to one or more shipping addresses.{" "}
                    </div>
                  </div>
                </div>
                <div className="overlay-content">
                  <div className="order-type margin-top2">
                    <div className="cart-icon-container">
                      <div className="cart-icon3">
                        <i className="fa fa-clinic-medical"></i>
                      </div>
                    </div>
                    <div className="returns-content">
                      {" "}
                      <strong>SHIP TO HEALTH CARE PROVIDER(S)</strong>
                      <br />
                      Ship this order to a Health Care Provider(s).{" "}
                    </div>
                  </div>
                </div>
                <div className="overlay-content">
                  <div className="order-type margin-top2">
                    <div className="cart-icon-container">
                      <div className="cart-icon3">
                        <i className="fa fa-hotel"></i>
                      </div>
                    </div>
                    <div className="returns-content">
                      {" "}
                      <strong>SHIP TO EVENT SITE</strong>
                      <br />
                      Ship this order to an event location.{" "}
                    </div>
                  </div>
                </div>
                <button
                  onClick={onClose}
                  className="btn-gray text-center  margin-top1"
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="group">
          <div className="home-banner">
            <div className="span5 margin-top">
              <h1 className="black">
                Welcome to
                <br />
                {appName?.showField ? (
                  <strong>
                    {appName?.clientSpecificLabel || appName?.defaultLabel}
                  </strong>
                ) : (
                  ""
                )}
              </h1>
              {WelcomeMessage?.showField ? (
                <p>
                  {WelcomeMessage?.clientSpecificLabel ||
                    WelcomeMessage?.defaultLabel}
                </p>
              ) : (
                ""
              )}
              <div className="des-btn-container margin-top">
                <div className="group">
                  <div className="span6">
                    {StartAnOrder?.showField ? (
                      <button
                        onClick={onStartAnOrder}
                        className="banner-btn btn-primary"
                      >
                        {StartAnOrder?.clientSpecificLabel ||
                          StartAnOrder?.defaultLabel}
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="span6">
                    {ContactSupportButton?.showField ? (
                      <button onClick={onContactSupport} className="banner-btn">
                        {ContactSupportButton?.clientSpecificLabel ||
                          ContactSupportButton?.defaultLabel}
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="group">
          {recentlyAdded.length ? (
            <RecentlyAddedItems
              recentlyAddedList={recentlyAdded}
              rightArrow={rightArrow}
              leftArrow={leftArrow}
              title={
                RecentlyAdded?.clientSpecificLabel ||
                RecentlyAdded?.defaultLabel
              }
              titleVisible={RecentlyAdded?.showField}
            />
          ) : null}
          {tagList && tagList?.length && Categories?.showField ? (
            <div className="span12">
              <div className="margin-top1">
                <h2 className="black">
                  <strong>
                    {Categories?.clientSpecificLabel ||
                      Categories?.defaultLabel}
                  </strong>
                </h2>

                <div className="group margin-top2">
                  <div className="filter span12">
                    {tagList?.map(({ name, tagId }, index) => (
                      <Fragment key={index}>
                        {tagId ? (
                          <div
                            key={index}
                            onClick={() => onCategorySelect({ tagId, name })}
                            className="catagories"
                          >
                            {name}
                          </div>
                        ) : null}
                      </Fragment>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {recentlyViewed.length ? (
            <RecentlyViewed
              recentlyViewedList={recentlyViewed}
              rightArrow={rightArrow}
              leftArrow={leftArrow}
              title={
                RecentlyViewedField?.clientSpecificLabel ||
                RecentlyViewedField?.defaultLabel
              }
              titleVisible={RecentlyViewedField?.showField}
            />
          ) : null}
        </div>
      </div>
    </main>
  );
}

export default LandingPageComp;
